/** Must match `upload_my_avatar` / `upload_my_banner` in `api/apps/profiles/api.py`. */
export const PROFILE_AVATAR_MAX_BYTES = 5 * 1024 * 1024

export const PROFILE_BANNER_MAX_BYTES = PROFILE_AVATAR_MAX_BYTES
